import React from "react";
import Avatar from "material-ui/Avatar";
import { connect } from "react-redux";
import Menu, { MenuItem } from "material-ui/Menu";
import IntlMessages from "util/IntlMessages";
import { withRouter } from "react-router-dom";
import { signOut } from "util/user-manager";
import { NotificationContainer } from "react-notifications";
import { persistConfig } from "store/index";
import { purgeStoredState } from "redux-persist";
import * as CONST from "util/app-constants";

class UserInfo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      open: false,
      imageUrl: (
        <Avatar
          alt="..."
          src={CONST.DEFAULT_PROFILE_IMG}
          className="user-avatar"
        />
      ),
      deviceId: this.props.symbioticReducer.deviceId,
    };

    this.updateUsernameInStore.bind(this);
  }

  handleClick = (event) => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  openProfileModal = () => {
    this.props.history.push("/app/components/profile-and-settings");
  };

  updateUsernameInStore = (name) => {
    this.props.changeUsername(name);
  };

  componentDidMount() {
    // const self = this;
    //
    // $('#profileModal').on('hidden.bs.modal', function (e) {
    //
    //     self.setState({
    //         profileModal: ''
    //     });
    //
    //     self.setState({
    //         profileModal: <ProfileModal resetProfileModal={true}/>
    //     })
    // })

    $(document).ready(() => {
      $(".myImage :first-child").bind("error", function () {
        // Replacing image source
        $(this).attr("src", CONST.DEFAULT_PROFILE_IMG);
      });
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.profileInfo.hasOwnProperty("userAttributes")) {
      if (
        nextProps.profileInfo.userAttributes !== null &&
        nextProps.profileInfo.userAttributes.hasOwnProperty("picture")
      ) {
        if (
          nextProps.profileInfo.userAttributes.picture !== this.state.imageUrl
        ) {
          if (nextProps.profileInfo.userAttributes.picture) {
            this.setState({
              imageUrl: (
                <Avatar
                  alt="..."
                  src={nextProps.profileInfo.userAttributes.picture}
                  className="user-avatar myImage"
                  id="profileImg"
                  onError={(e) => {
                    e.target.src = CONST.DEFAULT_PROFILE_IMG;
                  }}
                />
              ),
            });
          }
        }
      }
    }

    if (nextProps.symbioticReducer.deviceId !== this.state.deviceId) {
      this.setState({
        deviceId: nextProps.symbioticReducer.deviceId,
      });
    }
  }

  signUserOutInnerFunctionality = () => {
    this.props.signOut();
    this.props.setDefaultTheme();
    const body = $("#body");
    body.removeClass();
    body.addClass(this.props.themeColor);
    purgeStoredState(persistConfig);
  };

  signUserOut = () => {
    signOut().then(
      () => {
        this.signUserOutInnerFunctionality();
      },
      () => {
        this.signUserOutInnerFunctionality();
      }
    );
  };

  openAdminPanel = () => {
    this.props.history.push("/app/components/admin-panel");
  };

  render() {
    return (
      <div className="user-profile d-flex flex-row align-items-center">
        {/* {this.state.imageUrl} */}
        {/* <object src="assets/images/symbiotic.png"> */}
        {this.state.imageUrl}
        {/* </object> */}
        {/* <img className="MuiAvatar-img-7165" src={this.state.imageUrl} onError={(e)=>{e.target.src="assets/images/symbiotic.png"}} /> */}
        <div className="user-detail">
          <h4 className="user-name text-black" onClick={this.handleClick}>
            {this.props.profileInfo.username}{" "}
            <i className="zmdi zmdi-caret-down zmdi-hc-fw align-middle" />
          </h4>
        </div>
        <Menu
          className="user-info"
          id="simple-menu"
          anchorEl={this.state.anchorEl}
          open={this.state.open}
          onClose={this.handleRequestClose}
          PaperProps={{
            style: {
              width: 150,
              paddingTop: 0,
              paddingBottom: 0,
            },
          }}
        >
          <MenuItem
            onClick={() => {
              //   this.handleRequestClose();
              //   this.openProfileModal();
            }}
          >
            <i className="zmdi zmdi-account zmdi-hc-fw mr-2" />
            <IntlMessages id="popup.profile" />
          </MenuItem>
          {/* {this.props.profileInfo.isAdmin ? (
            <MenuItem
              className="pr-4"
              onClick={() => {
                this.handleRequestClose();
                this.openAdminPanel();
              }}
            >
              <i className="zmdi zmdi-settings zmdi-hc-fw mr-2" />
              <IntlMessages id="popup.setting"/>
              Admin Panel
            </MenuItem>
          ) : (
            ""
          )} */}
          <MenuItem
            onClick={() => {
              this.handleRequestClose();
              this.signUserOut();
            }}
          >
            <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-2" />

            <IntlMessages id="popup.logout" />
          </MenuItem>
        </Menu>
        <NotificationContainer />
      </div>
    );
  }
}

const mapStateToProps = ({ settings, profileInfo, symbioticReducer }) => {
  const { locale } = settings;
  return { locale, profileInfo, symbioticReducer };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeUsername: (name) => {
      dispatch({ type: "UPDATE_USERNAME", payload: name });
    },
    signOut: () => {
      dispatch({ type: "SIGN_OUT" });
    },
    setDefaultTheme: () => {
      dispatch({ type: "SET_DEFAULT_THEME" });
    },
  };
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UserInfo)
);



// WEBPACK FOOTER //
// ./components/UserInfo/index.js